<div
  #tooltipRef
  class="kros-tooltip"
  [ngClass]="tooltipClass"
>
  <div class="kros-tooltip__content">
      @if (isStringContent(tooltip)) {
        {{ tooltip }}
      } @else {
        <ng-container [ngTemplateOutlet]="tooltip" [ngTemplateOutletContext]="context"></ng-container>
      }
  </div>
</div>
